import { render, staticRenderFns } from "./AboutBanner.vue?vue&type=template&id=55ea7fcc&scoped=true&"
import script from "./AboutBanner.vue?vue&type=script&lang=js&"
export * from "./AboutBanner.vue?vue&type=script&lang=js&"
import style0 from "./AboutBanner.vue?vue&type=style&index=0&id=55ea7fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea7fcc",
  null
  
)

export default component.exports